import React from "react";
import { Input } from "antd";

import type { InputProps } from "antd";

interface TypePhoneNumberProps extends Omit<InputProps, "onChange"> {
  onChange?(value: string): void;
}

export function fixPhoneInput(input: string | undefined) {
  if (!input) return;
  // 移除所有非数字字符（除了括号和连字符）
  const cleanedInput = input.replace(/[^\d()\-]/g, "");

  // 如果输入以 'N' 开头，直接返回
  if (cleanedInput[0] === "N") return cleanedInput;

  // 确保最多只有 10 位数字
  const digits = cleanedInput.replace(/\D/g, "").slice(0, 10);

  // 格式化为 (xxx) xxx-xxxx
  if (digits.length <= 3) {
    return `(${digits}`;
  } else if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`; // <-- 区号后用空格
  } else {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(
      6,
      10,
    )}`;
  }
}

/**
 * @name PhoneNumber 联系电话
 * @description 转换成美国的电话格式
 */
const PhoneNumber: React.FC<TypePhoneNumberProps> = ({
  onChange,
  ...props
}) => (
  <Input
    size="large"
    {...props}
    onChange={(e) => onChange?.(fixPhoneInput(e.target.value))}
  />
);

export default PhoneNumber;
